import isNil from 'lodash/isNil'
import { convertToDefaultCurrency } from '@omnea-app/packages/universal/currency-utils/convertToDefaultCurrency'
import { Price } from '@omnea-app/requests/price'
import { CurrencyCode } from 'utils/currency/getCurrencyCodes'
import { CoreDataCurrency } from 'utils/currency/hooks/useOrganisationCurrencies'
import { Dictionary } from 'utils/utiltyTypes/utilityTypes'

type Input = {
  price: Price
  defaultCurrency?: CurrencyCode
  currenciesByCode?: Dictionary<CoreDataCurrency>
}

export const getAmountInDefaultCurrency = ({ price, defaultCurrency, currenciesByCode }: Input): number | undefined => {
  if (isNil(price.fxRate)) return

  if (price.currency === defaultCurrency) return price.amount

  if (!defaultCurrency) return Math.round((price.amount / price.fxRate) * 100) / 100

  const defaultCurrencyFxRate = currenciesByCode?.[defaultCurrency]?.fxRate ?? 1

  return (
    convertToDefaultCurrency({
      value: price.amount,
      valueCurrencyCode: price.currency,
      defaultCurrencyCode: defaultCurrency,
      fxRatesByCode: {
        [price.currency]: price.fxRate,
        [defaultCurrency]: defaultCurrencyFxRate,
      },
    }) ?? undefined
  )
}
